import "./components/nav-toggler.js";

import rangeSlider from "./loanCalculator/rangeslider"
import interestFreeMonths from "./loanCalculator/interestFreeMonths"
import intervals from './loanCalculator/intervals'
import loanIntervals from './loanIntervals'
import formSlide from './components/form-slides.js'
import formSlideSE from './components/form-slides-se.js'
import formArrow from './components/form-arrow.js'
import './components/form-toggle-fields'
import './components/decimal-seperator'
import './components/form-tooltip'


